export const googleMapTypes = Object.freeze({
  SET_CENTER_MAP: 'SET_CENTER_MAP',
  SET_ZOOM_MAP: 'SET_ZOOM_MAP',
  SET_GOOGLE_KEY: 'SET_GOOGLE_KEY'
})
